const helpers = {
    cutText(text, length) {
        if (text.split(" ").length > 1) {
            let string = text.substring(0, length);
            let splitText = string.split(" ");
            splitText.pop();
            return splitText.join(" ") + "...";
        } else {
            return text;
        }
    },
    formatDate(date, format) {
        return date;
    },
    capitalizeFirstLetter(string) {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },
    onlyNumber(number) {
        if (number) {
            return number.replace(/\D/g, "");
        } else {
            return "";
        }
    },
    formatCurrency(number) {
        if (number) {
            let formattedNumber = number.toString().replace(/\D/g, "");
            let rest = formattedNumber.length % 3;
            let currency = formattedNumber.substr(0, rest);
            let thousand = formattedNumber.substr(rest).match(/\d{3}/g);
            let separator;

            if (thousand) {
                separator = rest ? "." : "";
                currency += separator + thousand.join(".");
            }

            return currency;
        } else {
            return "";
        }
    },
    isset(obj) {
        return Object.keys(obj).length;
    },
    assign(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    delay(time) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    },
    randomNumbers(from, to, length) {
        let numbers = [0];
        for (let i = 1; i < length; i++) {
            numbers.push(Math.ceil(Math.random() * (from - to) + to));
        }

        return numbers;
    },
    replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, "g"), replace);
    },
    calculateComission(inbound, type, website_top_leads = null) {
        let days = 1;
        if(inbound.export_status_date != null && inbound.export_status_date != '' && (inbound.sold_date == '' || inbound.sold_date == null)){
            let first = (new Date().getFullYear())+'-'+((new Date().getMonth() + 1) < 10 ? ('0'+ (new Date().getMonth() + 1)) : (new Date().getMonth() + 1))+'-'+(new Date().getDate())
            const date1 = new Date(first);
            const date2 = new Date(inbound.export_status_date);
            const diffTime = Math.abs(date2 - date1);
            days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));            
        }
        else if(inbound.export_status_date != null && inbound.export_status_date != '' && inbound.sold_date != '' && inbound.sold_date != null){
            const date1 = new Date(inbound.export_status_date);
            const date2 = new Date(inbound.sold_date);
            const diffTime = Math.abs(date2 - date1);
            days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        }
        
        let seller = 0;
        let co_seller = 0;
        
        if (inbound.seller_id != null && inbound.co_seller_id != null && inbound.seller_id != '' && inbound.co_seller_id != '' && inbound.seller_id != 0 && inbound.co_seller_id != 0) {
            if(type == 'seller' || type == 'both'){
                seller = inbound.top_order_sold == '1' ? 100 : (days > 90 ? 75 :50);
            }
            if(type == 'co_seller' || type == 'both'){
                co_seller = inbound.top_order_sold == '1' ? 100 : (days > 90 ? 75 :50);
            }
            return +seller + +co_seller;
        }
        else if (inbound.seller_id != '' && inbound.seller_id != null && inbound.seller_id != 0 && (inbound.co_seller_id == 0 || inbound.co_seller_id == '' || inbound.co_seller_id == null)) {
            seller = inbound.top_order_sold == '1' ? 200 : (days > 90 ? 150 :100);
            return +seller + +co_seller;
        }
        else{
            let top_order_sold = '0';
            if(website_top_leads.length > 0){
                top_order_sold = website_top_leads && website_top_leads.filter(result => {return result.id == inbound.id })[0] ? '1' : '0';
            }

            if(inbound.top_order_sold == '1'){
                top_order_sold = inbound.top_order_sold;
            }
            if(type == 'seller'){
                seller = top_order_sold == '1' ? 200 : (days > 90 ? 150 :100);
            }
            if(type == 'co_seller'){
                co_seller = top_order_sold == '1' ? 200 : (days > 90 ? 150 :100);
            }
            if(type == 'both'){
                seller = top_order_sold == '1' ? 100 : (days > 90 ? 75 :50);
                co_seller = top_order_sold == '1' ? 100 : (days > 90 ? 75 :50);
            }
            return +seller + +co_seller;
        }
    },
};

export default helpers;
